module.exports = __webpack_public_path__ + "img/herosection.528ce10e.gif";